import React, { useMemo } from 'react';
import { useStableId } from "./useStableId.js";
import { ErrorMessage } from "../components/errorMessage/ErrorMessage.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const useErrorProps = ({
  error,
  className,
  identifier
}) => {
  const errorMessageId = useStableId();
  const hasError = useMemo(() => typeof error === 'string' && error !== '', [error]);
  return useMemo(() => {
    if (hasError) {
      return {
        errorMessageId,
        errorInputProps: {
          'aria-invalid': 'true',
          'aria-errormessage': errorMessageId
        },
        errorMessage: /*#__PURE__*/_jsx(ErrorMessage, {
          id: errorMessageId,
          identifier: identifier,
          className: className,
          children: error
        }),
        hasError: true
      };
    }
    return {
      errorMessageId,
      hasError: false
    };
  }, [className, error, errorMessageId, hasError, identifier]);
};